import { FxpHttpService } from '@fxp/fxpservices';
import { FXPServiceCatalog, FxpServiceFactory } from '@fxp/fxpservices-di';
import { RAvailUrlProvider } from '../../common/RAvailUrlProvider';
import {
  AssignmentSearchRequest,
  AssignmentSearchResponse,
} from '../contracts/DSEContracts';

export interface IDSEAssignmentSearchService {
  searchAssignments: (alias: string) => Promise<AssignmentSearchResponse>;
}

const JSON_HEADERS = { 'Content-Type': 'application/json' };

const SELECT_FIELDS = [
  'ProjectId',
  'AssignedResource',
  'ProjectName',
  'ScheduledStartDate',
  'ScheduledEndDate',
  'ResourceRequestStatusEnum',
  'ScheduleDuration',
  'Role',
  'Signed',
  'DeliveryCountryName',
  'DemandSourceId',
  'ProjectResourceManager',
  'RequestedDurationInHours',
  'RequestedStartDate',
  'RequestedEndDate',
  'Tpid',
];

/** Build the legacy GRM DSE assignment-search request without depending on the FXP shell. */
export const buildDSEAssignmentSearchRequest = (
  alias: string
): AssignmentSearchRequest => {
  const normalizedAlias = (alias || '').trim().toLowerCase();
  return {
    count: true,
    pageSize: 1000,
    pageIndex: 1,
    selectFields: SELECT_FIELDS.slice(),
    filters: [
      {
        facetValues: [
          { label: normalizedAlias },
          { label: normalizedAlias.toUpperCase() },
        ],
        id: 'AssignedResource',
        type: 'Edm.String',
      },
      {
        facetValues: [{ label: 'Support' }],
        id: 'DemandSourceType',
        type: 'Edm.String',
      },
      {
        facetValues: [{ label: 'DSEStaffing' }, { label: 'Scoping' }],
        id: 'RequestType',
        type: 'Edm.String',
      },
    ],
  };
};

const DSEAssignmentSearchService = (function () {
  let _instance: IDSEAssignmentSearchService;

  function createInstance(): IDSEAssignmentSearchService {
    const urlProvider = new RAvailUrlProvider();
    const httpService = FxpServiceFactory.getServiceInstance(
      FXPServiceCatalog.FxpHttpService
    ) as FxpHttpService;

    const searchAssignments = async (
      alias: string
    ): Promise<AssignmentSearchResponse> => {
      const response = await httpService.post(
        urlProvider.GetDSEAssignmentSearchUrl(),
        buildDSEAssignmentSearchRequest(alias),
        JSON_HEADERS
      );
      return response?.data as AssignmentSearchResponse;
    };

    return { searchAssignments };
  }

  return {
    getSingleton: (): IDSEAssignmentSearchService => {
      if (!_instance) {
        _instance = createInstance();
      }
      return _instance;
    },
  };
})();

export default DSEAssignmentSearchService;
